import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ControlConfig } from '../form-config.model';
import { AbregelungsinformationenTase2Adressen } from '../../../domain/model/abregelungsinformationen-tase2-adressen.model';

export class Tase2Validator {

    public static allFieldsPresentValidator(requiredField: boolean): ValidatorFn {
        return (formGroup: UntypedFormGroup): ValidationErrors | null => {
            const controls = formGroup.controls as ControlConfig<AbregelungsinformationenTase2Adressen>;

            if (controls.tase2Objekt.disabled && controls.elementTyp.disabled) {
                return null;
            }

            const filledEntries = [
                controls.tase2Objekt.value,
                controls.elementTyp.value,
            ].filter(f => f !== undefined && f !== null).length;

            if (filledEntries > 0 && filledEntries < 2) {
                return { fillAllValues: true };
            }
            if (requiredField && filledEntries < 2) {
                return { fillAllValues: true };
            }
            return null;
        };
    }
}
